import React, { useState, useEffect } from "react";
import { Dialog } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import Button from "../../../components/CustomButtons/Button";
import CustomInputValid from "../../../components/CustomInput/CustomInputValid";
import FileUploader from "../../../components/FileUploader/FileUploader";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";

const GuarantorPopup = (props) => {
    const { open, close, onSave, initial } = props;
    const [name, setName] = useState("");
    const [uploadId, setUploadId] = useState("");

    useEffect(() => {
        if (open) {
            setName(initial ? initial.name || "" : "");
            setUploadId(initial ? initial.upload_id || "" : "");
        }
    }, [open, initial]);

    const canSave = name && name.trim().length > 0;

    return (
        <Dialog open={open} keepMounted maxWidth="md" fullWidth={true}>
            <div><span className="close-btn" onClick={close}><Close /></span></div>
            <div style={{ padding: "0px 20px 40px" }}>
                <h3 className="text-center">{initial ? "Edit Guarantor" : "Add Guarantor"}</h3>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <CustomInputValid
                            label="Guarantor Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        {!canSave && <div className="red-text small-text">Required</div>}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className="boxed mt-20">
                            <p>Guarantor ID (optional)</p>
                            <FileUploader
                                update={(val) => setUploadId(val)}
                                remove={() => setUploadId("")}
                                the_filename={uploadId}
                                type="rs"
                            />
                        </div>
                    </GridItem>
                </GridContainer>
                <div className="mt-20 text-center">
                    <Button
                        color="primary"
                        className="mr-20"
                        disabled={!canSave}
                        onClick={() => {
                            if (!canSave) return;
                            onSave({ name: name.trim(), upload_id: uploadId });
                        }}
                    >SAVE</Button>
                    <Button color="white" onClick={close}>CANCEL</Button>
                </div>
            </div>
        </Dialog>
    );
};

export default GuarantorPopup;
